<template>
  <div class="service">
    <Header />
    <div class="introduction">
      <div class="content content__box">
        <div class="left">
          <div class="title">云POS</div>
          <div class="title__tips">
            满足移动端和台式PC端的智能收银POS，实现随时快速收银，提升用户购物体验
          </div>
          <div class="btn__box">
            <span class="btn-detail" @click="linkTo('/register')">
              免 费 试 用
            </span>
          </div>
        </div>
        <div class="right"></div>
      </div>
    </div>
    <div id="navagation" class="navagation">
      <div class="content content__box" :class="{ isFixed: isFixed }">
        <div class="nav__item"><a href="#Cfunction">产品功能</a></div>
        <div class="nav__item"><a href="#Cadvantage">产品优势</a></div>
        <div class="nav__item"><a href="#Cscene">应用场景</a></div>
      </div>
    </div>
    <div id="Cfunction"></div>
    <div class="product">
      <div class="content content__box">
        <div class="product__title">产品功能</div>
        <div class="product__detail">
          <div class="left"></div>
          <div class="right">
            <div class="title">商品销售</div>
            <div class="title__tips">
              完成门店商品销售收银，支持余额支付、积分支付、使用优惠券支付的收银功
              能，销售时可完成挂单等基本销售收银功能得会员权益，引诱更多会员购买商
              品销售
            </div>
            <div class="product__item">
              <div class="item__icon"></div>
              <div class="item__name">收银支付</div>
            </div>
            <div class="product__item">
              <div class="item__icon"></div>
              <div class="item__name">商品查询</div>
            </div>
            <div class="product__item">
              <div class="item__icon"></div>
              <div class="item__name">商品扫码</div>
            </div>
            <div class="product__item">
              <div class="item__icon"></div>
              <div class="item__name">商品销售</div>
            </div>
            <div class="product__item">
              <div class="item__icon"></div>
              <div class="item__name">……</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="productOperate">
      <div class="content content__box">
        <div class="left">
          <div class="title">库存调拨</div>
          <div class="title__tips">
            门店库存可在POS上申请调拨、采购，查看库存调整的记录，商品销售时会实时更新库存
          </div>
          <div class="product__item">
            <div class="item__icon"></div>
            <div class="item__name">采购商品</div>
          </div>
          <div class="product__item">
            <div class="item__icon"></div>
            <div class="item__name">库存调拨</div>
          </div>
          <div class="product__item">
            <div class="item__icon"></div>
            <div class="item__name">……</div>
          </div>
        </div>
        <div class="right"></div>
      </div>
    </div>
    <div id="Cadvantage"></div>
    <div class="advantage">
      <div class="content content__box">
        <div class="advantage__title">产品优势</div>
        <div class="advantage__detail">
          <div class="advantage__item">
            <div class="item__icon item__icon01"></div>
            <div class="item__title">收银便捷</div>
            <div class="item__tips">
              提供移动POS，可随时随地进行收银，实现收银的便捷
            </div>
          </div>
          <div class="advantage__item">
            <div class="item__icon item__icon02"></div>
            <div class="item__title">多种支付方式</div>
            <div class="item__tips">
              覆盖市面上大部分的多种支付方式，满足大部分会员的支付场景
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="Cscene"></div>
    <div class="application">
      <div class="content content__box">
        <div class="application__title">应用场景</div>
        <div class="application__list">
          <div class="item item-active">移动收银</div>
        </div>
        <div class="application__item">
          <div class="left"></div>
          <div class="right">
            <div class="title">移动收银</div>
            <div class="title__tips">
              允许导购拿着移动POS向用户推荐商品后直接收银，实现收银便捷，提升用户购物消费的体验
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
export default {
  name: "service",
  components: { Header, Footer },
  data() {
    return {
      isFixed: false,
      offsetTop: 442
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("scroll", this.watchScroll);
      this.offsetTop = document.querySelector("#navagation").offsetTop;
    });
  },
  methods: {
    watchScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.isFixed = scrollTop > this.offsetTop ? true : false;
    },
    linkTo(url) {
      this.$router.push({
        path: url
      });
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.watchScroll);
  }
};
</script>
<style lang="scss" scoped>
.content {
  width: 1200px;
  margin: 0 auto;
  user-select: none;
}
.introduction {
  padding-top: 77px;
  padding-bottom: 77px;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: auto 100%;
  background-image: url("../../../assets/img/service/public/2290@2x.png");
  .content__box {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    .left {
      width: 601px;
      text-align: left;
      margin-right: 169px;
      .title {
        padding-top: 35px;
        font-size: 44px;
        font-weight: bold;
        line-height: 62px;
        color: rgba(255, 255, 255, 1);
      }
      .title__tips {
        width: 612px;
        padding-top: 24px;
        font-size: 18px;
        font-weight: 400;
        line-height: 25px;
        color: rgba(255, 255, 255, 1);
      }
      .btn__box {
        padding-top: 48px;
        .btn-detail {
          display: inline-block;
          text-align: center;
          width: 140px;
          height: 38px;
          border-radius: 19px;
          font-size: 14px;
          font-weight: 400;
          line-height: 38px;
          color: rgba(62, 113, 255, 1);
          border: 1px solid #3e71ff;
          cursor: pointer;
        }
        .btn-detail:hover {
          background: rgba(62, 113, 255, 1);
          box-shadow: 0px 3px 6px rgba(62, 113, 255, 0.2);
          color: rgba(255, 255, 255, 1);
          border: 1px solid rgba(62, 113, 255, 0.2);
        }
      }
    }
    .right {
      width: 350px;
      height: 290px;
      background-repeat: no-repeat;
      background-position: top center;
      background-size: 100% 100%;
      background-image: url("../../../assets/img/service/retail/11@2x.png");
    }
  }
}
.navagation {
  background-color: #fff;
  .content__box {
    width: 100%;
    background-color: #fff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .nav__item {
      width: 260px;
      height: 62px;
      font-size: 16px;
      font-weight: 400;
      line-height: 62px;
      color: rgba(41, 43, 58, 1);
      cursor: pointer;
    }
  }
  .isFixed {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 11;
  }
}
.product {
  background: rgba(248, 250, 253, 1);
  .content__box {
    .product__title {
      padding-top: 80px;
      padding-bottom: 40px;
      font-size: 30px;
      font-weight: bold;
      line-height: 42px;
      color: rgba(41, 43, 58, 1);
      opacity: 1;
    }
    .product__detail {
      padding: 25px 0 21px 67px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      .left {
        width: 505px;
        height: 454px;
        background-repeat: no-repeat;
        background-position: top center;
        background-size: 100% 100%;
        background-image: url("../../../assets/img/service/retail/2609@2x.png");
      }
      .right {
        width: 476px;
        margin-left: 141px;
        text-align: left;
        .title {
          padding-top: 36px;
          padding-bottom: 30px;
          font-size: 26px;
          font-weight: bold;
          line-height: 37px;
          color: rgba(41, 43, 58, 1);
        }
        .title__tips {
          font-size: 14px;
          font-weight: 400;
          line-height: 26px;
          color: rgba(41, 43, 58, 1);
          padding-bottom: 20px;
        }
        .product__item {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 44px;
          .item__icon {
            width: 21px;
            height: 21px;
            background-repeat: no-repeat;
            background-position: top center;
            background-size: 100% 100%;
            background-image: url("../../../assets/img/public/499@2x.png");
          }
          .item__name {
            margin-left: 10px;
            font-size: 14px;
            font-weight: 400;
            line-height: 26px;
            color: rgba(41, 43, 58, 1);
          }
        }
      }
    }
  }
}
.productOperate {
  padding-top: 29px;
  padding-bottom: 17px;
  background: rgba(255, 255, 255, 1);
  .content__box {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    .left {
      width: 492px;
      margin-right: 148px;
      padding-left: 30px;
      text-align: left;
      .title {
        padding-top: 103px;
        padding-bottom: 30px;
        font-size: 26px;
        font-weight: bold;
        line-height: 37px;
        color: rgba(41, 43, 58, 1);
      }
      .title__tips {
        font-size: 14px;
        font-weight: 400;
        line-height: 26px;
        color: rgba(41, 43, 58, 1);
        padding-bottom: 20px;
      }
      .product__item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 44px;
        .item__icon {
          width: 21px;
          height: 21px;
          background-repeat: no-repeat;
          background-position: top center;
          background-size: 100% 100%;
          background-image: url("../../../assets/img/public/499@2x.png");
        }
        .item__name {
          margin-left: 10px;
          font-size: 14px;
          font-weight: 400;
          line-height: 26px;
          color: rgba(41, 43, 58, 1);
        }
      }
    }
    .right {
      width: 436px;
      height: 417px;
      background-repeat: no-repeat;
      background-position: top center;
      background-size: 100% 100%;
      background-image: url("../../../assets/img/service/retail/2610@2x.png");
    }
  }
}
.advantage {
  padding-bottom: 80px;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% 100%;
  background-image: url("../../../assets/img/service/public/2286@2x.png");
  .content__box {
    .advantage__title {
      padding-top: 80px;
      padding-bottom: 40px;
      font-size: 30px;
      font-weight: bold;
      line-height: 42px;
      color: rgba(41, 43, 58, 1);
      opacity: 1;
    }
    .advantage__detail {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      background: rgba(255, 255, 255, 1);
      .advantage__item {
        padding-top: 103px;
        width: 600px;
        padding-bottom: 60px;
        text-align: center;
        .item__icon {
          width: 100px;
          height: 100px;
          margin: 0 auto;
          background-repeat: no-repeat;
          background-position: top center;
          background-size: 100% 100%;
        }
        .item__icon01 {
          background-image: url("../../../assets/img/service/retail/2140@2x.png");
        }
        .item__icon02 {
          background-image: url("../../../assets/img/service/retail/2152@2x.png");
        }
        // .item__icon03 {
        //   // background-image: url("../../../assets/img/service/retail/2575@2x.png");
        // }
        // .item__icon04 {
        //   // background-image: url("../../../assets/img/service/retail/2498@2x.png");
        // }
        .item__title {
          padding-top: 73px;
          font-size: 26px;
          font-weight: bold;
          line-height: 37px;
          color: rgba(41, 43, 58, 1);
          margin: 0 auto;
        }
        .item__tips {
          padding-top: 30px;
          width: 240px;
          height: 77px;
          font-size: 14px;
          font-weight: 400;
          line-height: 26px;
          color: rgba(41, 43, 58, 1);
          margin: 0 auto;
        }
      }
    }
  }
}
.application {
  padding-bottom: 80px;
  background: rgba(255, 255, 255, 1);
  .content__box {
    .application__title {
      padding-top: 80px;
      padding-bottom: 18px;
      font-size: 30px;
      font-weight: bold;
      line-height: 42px;
      color: rgba(41, 43, 58, 1);
      opacity: 1;
    }
    .application__list {
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid rgba(41, 43, 58, 0.1);
      .item {
        width: 285px;
        height: 84px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: 400;
        color: rgba(41, 43, 58, 1);
        cursor: pointer;
      }
      .item-active {
        color: rgba(62, 113, 255, 1);
      }
      .item:hover {
        box-shadow: 0px 6px 20px rgba(41, 43, 58, 0.08);
      }
    }
    .application__item {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 40px 40px 0 40px;
      .left {
        width: 632px;
        height: 210px;
        background-repeat: no-repeat;
        background-position: top center;
        background-size: 100% 100%;
        background-image: url("../../../assets/img/service/retail/2516@2x.png");
      }
      .right {
        width: 448px;
        text-align: left;
        .title {
          font-size: 26px;
          font-weight: bold;
          line-height: 37px;
          color: rgba(41, 43, 58, 1);
        }
        .title__tips {
          padding-top: 30px;
          width: 448px;
          height: 46px;
          font-size: 14px;
          font-weight: 400;
          line-height: 26px;
          color: rgba(41, 43, 58, 1);
        }
      }
    }
  }
}
@keyframes play {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
</style>
